<template>
    <FeatureGrid title="The modern Unified API+MCP platform, built differently" :features="benefits" />
</template>

<script lang="ts">
import { computed } from 'vue';
import { INTEGRATIONS_COUNT_10s } from '~~/services/integrations';
import { MAP_CATS } from '~~/services/categories';

export default {
    props: {
        deepNormalizedTitle: {
            type: String,
            default: 'Unified APIs, deeply normalized',
        },
    },
    setup(props: { deepNormalizedTitle: string }) {
        const benefits = computed(() => [
            {
                icon: 'ic:round-bolt',
                title: 'Real-time, pass-through',
                body: `Every request hits the source API live. No caching, no sync jobs, no stale data — just on-demand API reads/writes with native and virtual webhooks for instant updates.`,
            },
            {
                icon: 'ic:round-shield',
                title: 'Zero-storage by design',
                body: 'We never store end-customer data. Traffic is stateless and regionalized (US/EU/AU), reducing compliance scope and eliminating data-at-rest risk.',
            },
            {
                icon: 'ic:round-hub',
                title: props.deepNormalizedTitle,
                body: `${INTEGRATIONS_COUNT_10s}+ integrations, ${Object.keys(MAP_CATS).length} categories. Unified objects, endpoints, scopes, and errors—plus raw payload passthrough when you need integration-specific fields.`,
            },
            {
                icon: 'ic:round-dashboard-customize',
                title: 'Custom fields & objects',
                body: 'Go beyond shallow schemas. We support custom fields and read/write on custom objects (e.g., Salesforce) via unified metadata APIs.',
            },
            {
                icon: 'ic:round-auto-awesome',
                title: 'AI-ready integrations',
                body: 'Built for AI products: feed real-time data into embeddings or RAG pipelines, and let your agents perform secure write actions through MCP—all without caching or stale sync jobs.',
            },
            {
                icon: 'ic:round-lock-open',
                title: 'Predictable pricing, no lock-in',
                body: 'Transparent usage-based pricing that scales with API volume—not customers. Own your credentials and migrate anytime.',
            },
        ]);

        return {
            benefits,
        };
    },
};
</script>
